export default __webpack_public_path__ + "static/media/arrow-left.eb22a79e.svg";